export enum IarTab {
    OpenJobs = 0,
    MyOpenJobs = 1,
    AllJobs = 2,
}